import {
    Bold,
    Italic,
    Strikethrough,
    Underline,
    Highlighter,
    Eraser,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Pilcrow,
    Outdent,
    Indent,
    Undo,
    Redo
} from 'lucide-react'
import React, { useEffect, useState } from 'react'
import Tooltip from '../../common/Tooltip'

interface Props {
    onFormat: (command: string, value?: string) => void
}

const RichTextHeader: React.FC<Props> = ({ onFormat }) => {
    return (
        <div className='flex items-center gap-1'>
            <Tooltip label='Negrito'>
                <button type='button' onClick={() => onFormat('bold')} className='format-btn'>
                    <Bold className='w-4 h-4' />
                </button>
            </Tooltip>

            <Tooltip label='Itálico'>
                <button type='button' onClick={() => onFormat('italic')} className='format-btn'>
                    <Italic className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Riscado'>
                <button type='button' onClick={() => onFormat('strikethrough')} className='format-btn'>
                    <Strikethrough className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Sublinhado'>
                <button type='button' onClick={() => onFormat('underline')} className='format-btn'>
                    <Underline className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Destaque'>
                <button
                    type='button'
                    onClick={() => {
                        onFormat('hiliteColor', 'yellow')
                        onFormat('foreColor', 'black')
                    }}
                    className='format-btn'
                >
                    <Highlighter className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Alinhar à esquerda'>
                <button type='button' onClick={() => onFormat('justifyLeft')} className='format-btn'>
                    <AlignLeft className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Centralizar'>
                <button type='button' onClick={() => onFormat('justifyCenter')} className='format-btn'>
                    <AlignCenter className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Alinhar à direita'>
                <button type='button' onClick={() => onFormat('justifyRight')} className='format-btn'>
                    <AlignRight className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Justificar'>
                <button type='button' onClick={() => onFormat('justifyFull')} className='format-btn'>
                    <AlignJustify className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Recuar'>
                <button type='button' onClick={() => onFormat('outdent')} className='format-btn'>
                    <Outdent className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Avançar'>
                <button type='button' onClick={() => onFormat('indent')} className='format-btn'>
                    <Indent className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Desfazer'>
                <button type='button' onClick={() => onFormat('undo')} className='format-btn'>
                    <Undo className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Refazer'>
                <button type='button' onClick={() => onFormat('redo')} className='format-btn'>
                    <Redo className='w-4 h-4' />
                </button>
            </Tooltip>
            <Tooltip label='Limpar formatação'>
                <button type='button' onClick={() => onFormat('removeFormat')} className='format-btn'>
                    <Eraser className='w-4 h-4' />
                </button>
            </Tooltip>
        </div>
    )
}

export default RichTextHeader
